import axios from './axios';
const API_URL = '/C4-Nicaragua/Pagos'; 


export const addDocumentosPago = async (documentosPago) => {
  try {
     
    const response = await axios.post(API_URL, documentosPago);
    // console.log(response);
    return response.data;
  } catch (error) {
    // console.log(error);
    console.error('Error al guardar Documento de pago', error);
    throw error;
  }
};

export const  getDocumentosPagoPorFactura= async(idFactura)  =>
{
    try{
//console.log(idFactura);
//console.log(API_URL);
    const response = await axios.get(`${API_URL}/${idFactura}`);
    return response.data;    
    }
    catch(error)
    {
      console.error('Error al obtener factura del cliente', error);
      throw error;
    }
}